import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import Swal from "sweetalert2";
import { set_auth } from "../../reducers/Auth";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { PERMISSIONS } from "../../helper/permissionHelper";
import { withPageAccess } from "../common/ProtectedPage";
import Switch from "react-switch";
import {TourContext} from "../guideComponent/guideTourProvicer";

export class PayrollSetting extends Component {
    static contextType = TourContext;
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            prosesSimpan: false,
            isLoading: true,
            payroll_note: '',
            set_cuti: '0',
            set_izin: '0',
            persen_cuti: '0',
            set_lembur: '1',
            perusahaan: {},
            sum_qty: '0'
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    showModal = () => {
        this.setState({
            modal: true,
        });
    };

    handleOk = e => {
        this.setState({
            modal: false,
        });
    };

    handleCancel = e => {
        this.setState({
            modal: false,
        });
    };

    simpanPayrollSetting = () => {
        this.setState({
            prosesSimpan: true,
        })

        let form = {
            payroll_note: this.state.payroll_note,
            set_cuti : this.state.set_cuti,
            set_izin : this.state.set_izin,
            persen_cuti : this.state.persen_cuti,
            set_lembur : this.state.set_lembur,
            sum_qty : this.state.sum_qty,
        }

        this.props.request("payroll/set-note", form, 'POST')
            .then(response => {
                if (response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                    this.loadData()
                } else {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    prosesSimpan: false,
                })
            });
    }

    loadData() {
        this.setState({
            loading: true
        })
        let form = {}
        this.props.request("get_company", form, 'POST')
            .then(response => {
                if (response) {
                    this.setState({
                        payroll_note: response.data.perusahaan_payroll_note,
                        perusahaan: response.data,
                    })
                }
            })
        this.setState({
            loading: false
        })
    }

    loadPayset() {
        let form = {}
        this.props.request("payroll/list-payset", form, 'POST')
            .then(response => {
                if (response && response.pay_set && response.pay_set.length > 0) {
                    const payset = response.pay_set[0];
                    this.setState({
                        set_cuti: payset.payset_count_cuti,
                        set_izin: payset.payset_count_izin,
                        persen_cuti: payset.payset_cuti_percentage,
                        set_lembur: payset.payset_count_lembur,
                        sum_qty: payset.payset_show_term_value,
                    })
                }
            })
    }

    componentDidMount() {
        this.loadData()
        this.loadPayset()
    }
    componentDidMount() {
        this.loadData();
        this.loadPayset();

        this.tourTimeout = setTimeout(() => {
            const tourSteps = [
                {
                    selector: '.catatan-payroll', // ← fix: tambah titik
                    title: 'Catatan Payroll',
                    content: 'Isi kolom ini dengan catatan atau keterangan tambahan terkait pengaturan payroll perusahaan.'
                },
                {
                    selector: '.set_cuti',
                    title: 'Perhitungan Cuti',
                    content: 'Aktifkan toggle ini jika ingin mengikutsertakan perhitungan cuti dalam kalkulasi payroll karyawan.'
                },
                {
                    selector: '.set_lembur',
                    title: 'Perhitungan Lembur',
                    content: 'Aktifkan toggle ini jika ingin mengikutsertakan perhitungan lembur dalam kalkulasi payroll karyawan.'
                },
                {
                    selector: '.sum_qty', // ← perlu fix id di JSX juga
                    title: 'Tampilkan Jumlah Kompensasi/Potongan',
                    content: 'Aktifkan toggle ini jika ingin menampilkan jumlah kompensasi dan potongan secara rinci pada slip gaji karyawan.'
                }
            ];

            if (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0) {
                tourSteps.push({
                    selector: '.save',
                    title: 'Simpan Pengaturan',
                    content: 'Klik tombol ini untuk menyimpan seluruh perubahan pengaturan payroll perusahaan.'
                });
            }

            const { setSteps, setCurrent, setActive } = this.context;
            setSteps(tourSteps);
            setCurrent(0);
            setActive(true);
        }, 500);
    }

    componentWillUnmount() {
        clearTimeout(this.tourTimeout);
    }

    render() {
        return (
                <Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Pengaturan Payroll - Presensi</title>
                        <meta name="description" content="Detail Presensi" />
                    </Helmet>
                    <Breadcrumb title="Pengaturan Payroll Presensi" />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form className="needs-validation user-add" noValidate="">
                                            <h4>Pengaturan Payroll Perusahaan</h4>
                                            <div className="form-group row">
                                                <label className="col-xl-3 col-md-4">Catatan Payroll</label>
                                                {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0) ? (
                                                        <input name="payroll_note"
                                                               className="form-control col-xl-8 col-md-7 catatan-payroll"
                                                               placeholder="Catatan Payroll..."
                                                               type="text" required="" value={this.state.payroll_note}
                                                               onChange={this.handleChange}/>)
                                                    :
                                                    <span>{this.state.payroll_note}</span>
                                                }
                                            </div>
                                            <div className="form-group row mt-3 set_cuti">
                                                <label className="col-xl-3 col-md-4">Perhitungan Cuti</label>
                                                <Switch
                                                    id={'set_cuti'}
                                                    name="set_cuti"
                                                    checked={
                                                        this.state.set_cuti === '1'
                                                    }
                                                    onChange={(val) => {
                                                        this.setState({
                                                            set_cuti: val ? "1" : "0",
                                                            set_izin: val ? this.state.set_izin : "0",
                                                            persen_cuti: val ? this.state.persen_cuti : "0"
                                                        })
                                                    }}
                                                    onColor="#1890ff"
                                                    offColor="#eb4034"
                                                    handleDiameter={18}
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                    height={24}
                                                    width={48}
                                                    className="mr-1 switch-settings-app my-2"
                                                />
                                            </div>
                                            {this.state.set_cuti === '1' &&
                                                <>
                                                    <div className="form-group row">
                                                        <div className="col-xl-3 col-md-4">
                                                            <label className="ml-3">Hitung Sakit Sebagai Cuti</label>
                                                        </div>
                                                        <div className="ml-3 ml-md-0">
                                                            <Switch
                                                                id={'set_izin'}
                                                                name="set_izin"
                                                                checked={
                                                                    this.state.set_izin === '1'
                                                                }
                                                                onChange={(val) => {
                                                                    this.setState({
                                                                        set_izin: val ? "1" : "0"
                                                                    })
                                                                }}
                                                                onColor="#1890ff"
                                                                offColor="#eb4034"
                                                                handleDiameter={18}
                                                                uncheckedIcon={false}
                                                                checkedIcon={false}
                                                                boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                                height={24}
                                                                width={48}
                                                                className="mr-1 switch-settings-app my-2"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <div className="col-xl-3 col-md-4">
                                                            <label className="ml-3">Persentase perhitungan cuti/sakit</label>
                                                        </div>
                                                        <input name="persen_cuti"
                                                               className="form-control col-xl-8 col-md-7 ml-4 ml-md-0"
                                                               placeholder="Persentase perhitungan cuti/izin..."
                                                               type="number" value={this.state.persen_cuti}
                                                               onChange={(event) => {
                                                                   const {name, value} = event.target;
                                                                   let persen_cuti = Math.max(0, Math.min(100, Number(value)));
                                                                   this.setState({[name]: persen_cuti});
                                                               }}/>
                                                    </div>
                                                </>
                                            }
                                            <div className="form-group row mt-3 set_lembur">
                                                <label className="col-xl-3 col-md-4">Perhitungan Lembur</label>
                                                <Switch
                                                    id={'set_lembur'}
                                                    name="set_lembur"
                                                    checked={
                                                        this.state.set_lembur === '1'
                                                    }
                                                    onChange={(val) => {
                                                        this.setState({
                                                            set_lembur: val ? "1" : "0",
                                                        })
                                                    }}
                                                    onColor="#1890ff"
                                                    offColor="#eb4034"
                                                    handleDiameter={18}
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                    height={24}
                                                    width={48}
                                                    className="mr-1 switch-settings-app my-2"
                                                />
                                            </div>

                                            <div className="form-group row mt-3 sum_qty">
                                                <label className="col-xl-3 col-md-4">Tampilkan Jumlah Kompensasi/Potongan</label>
                                                <Switch
                                                    id={'set_lembur'}
                                                    name="set_lembur"
                                                    checked={
                                                        this.state.sum_qty === '1'
                                                    }
                                                    onChange={(val) => {
                                                        this.setState({
                                                            sum_qty: val ? "1" : "0",
                                                        })
                                                    }}
                                                    onColor="#1890ff"
                                                    offColor="#eb4034"
                                                    handleDiameter={18}
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                    height={24}
                                                    width={48}
                                                    className="mr-1 switch-settings-app my-2"
                                                />
                                            </div>

                                        </form>
                                        <div className="pull-right">
                                            {this.state.prosesSimpan === false ?
                                                <button type="button" className="btn btn-primary save"
                                                        onClick={this.simpanPayrollSetting}>Simpan</button>
                                                :
                                                <button type="button" className="btn btn-primary"><i
                                                    className="fa fa-refresh fa-spin"/> Loading</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
    }
}

const mapStateToProps = state => ({
    auth: state.Auth.auth,
    user: state.Auth.user,
    api_token: state.Auth.api_token
})

const mapDispatchToProps = dispatch => ({
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withPageAccess(PayrollSetting, PERMISSIONS.PENGATURAN_PAYROLL))
